import { PhoneNumberFormats } from '../phoneNumberFormatsByCountry'

export const US: PhoneNumberFormats = {
  placeholder: '(123) 456-7890',
  format: (num: string) =>
    num.length > 6 ? '(###) ###-####' : '(###) #######',
  phoneNumberMinLength: () => 10
}
